import Axios from 'axios'
import Jsonp from 'jsonp'
import Qs from 'qs/dist/qs'
import store from './store';
import {
  Dialog
} from 'vant'

// get(url, params) {
//     var obj = {
//         params: params
//     }
//     return Axios.get(url, obj)
// },
// post(url, params) {
//     return Axios.post(url, params)
// },
// post_formdata(url, params) {
//     return Axios.post(url, params, {
//         headers: {
//             'content-type': 'multipart/form-data; charset=UTF-8'
//         }
//     })
// },
// post_payload(url, params) {
//     return Axios.post(url, Qs.stringify(params), {
//         headers: {
//             'content-type': 'application/x-www-form-urlencoded;charset=UTF-8'
//         }
//     })
// },
var post_json = function(url, params) {
  return new Promise((resolve, reject) => {
    store.state.isLoading = true,
      Axios.post(url, params, {
        headers: {
          'content-type': 'application/json;charset=UTF-8',
          'sso': localStorage.getItem("sso") || '',
          'lang': localStorage.getItem("lang") || 'en',
          // 'Origin':'*'
        },
        timeout: 20000
      }).then(res => {
        store.state.isLoading = false
        //成功
        resolve(res)
      }).catch(res => {
        store.state.isLoading = false
        //失败
        Dialog.alert({
          title: '提示信息',
          message: '網絡不給力，請稍後再試',
        }).then(() => {
          // on close
        });
        reject(res)
      })
  })
};
export default {
  post_json
};



// WEBPACK FOOTER //
// ./src/request.js